import { Action, Reducer } from 'redux';
import {
  ManufacturerState,
  ManufacturerTypes,
  ManufacturerActionTypes
} from './manufacturerTypes';
import {
  haskeyReducer,
  resetIsolatedReducer,
  updateGetIsolated,
  updateSaveIsolated
} from '@/main/services/reducerUtils';

export const INITIAL_STATE: ManufacturerState = {
  manufacturers: {
    data: null,
    errorMessages: null,
    isError: false,
    isLoading: false
  },
  isolated: {}
};

const ManufacturerReducer: Reducer<ManufacturerState> = (
  state: ManufacturerState = INITIAL_STATE,
  action: Action
) => {
  const actionTypes = action as ManufacturerActionTypes;
  switch (actionTypes.type) {
    case ManufacturerTypes.GET_MANUFACTURERS:
      const isKeyReducer = haskeyReducer(actionTypes.payload.keyReducer);

      if (isKeyReducer) return updateGetIsolated(state, actionTypes);

      return {
        ...state,
        manufacturers: { ...state.manufacturers, isLoading: true }
      };
    case ManufacturerTypes.SAVE_MANUFACTURERS:
      const isKeyReducerSave = haskeyReducer(actionTypes.payload.keyReducer);

      if (isKeyReducerSave) return updateSaveIsolated(state, actionTypes);

      return {
        ...state,
        manufacturers: {
          ...state.manufacturers,
          isLoading: false,
          errorMessages: actionTypes.payload.errorMessages,
          isError: actionTypes.payload.isError,
          data: actionTypes.payload.data
        }
      };
    case ManufacturerTypes.RESET_REDUCER_MANUFACTURERS:
      const isKeyReducerReset = haskeyReducer(actionTypes.payload.keyReducer);

      if (isKeyReducerReset) return resetIsolatedReducer(state, actionTypes);

      return {
        ...state,
        manufacturers: INITIAL_STATE.manufacturers
      };
    default:
      return state;
  }
};

export default ManufacturerReducer;

